import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';


const Input = (props) => {
  const className = props.className ? `ov-input ${props.className}` : "ov-input";
  return (
      <input className={className} value={props.value} type={props.type} step={props.step} placeholder={props.placeholder}
        onChange={(e) => props.onChange(e.target.value)} disabled={props.disabled} readOnly={props.readOnly} dir="auto" />
  );
}


Input.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  type: PropTypes.string,
  step: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool
};

Input.defaultProps = {
  className: '',
  value: '',
  type: 'text',
  step: '',
  placeholder: '',
  onChange: ()=>{},
  disabled: false,
  readOnly: false
};



export { Input };
